import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';
import { ErrorResponse } from '@/utils/response';
import { axios, CustomAxiosResponse } from '@/utils/axios';
import { Folder } from './folder.model';

export interface FolderStoreInterface {
  folders: Folder[];
  folder: Folder | null;
  error: ErrorResponse | null;
  fetchFolderByUuid(uuid: string): Promise<void>;
  fetchFolderById(id: number): Promise<void>;
  fetchFolders(): Promise<void>;
  fetchRootFolders(): Promise<void>;
  fetchSubfolders(parentId: number): Promise<void>;
}

@Module({
  namespaced: true,
  dynamic: true,
  name: 'folder',
  store,
})
class FolderStore extends VuexModule {
  folders: Folder[] = [];
  folder: Folder | null = null;
  error: ErrorResponse | null = null;

  @Mutation
  updateFolders(params: Folder[]) {
    this.folders = params;
  }

  @Mutation
  updateFolder(params: Folder) {
    this.folder = params;
  }

  @Mutation
  setError(params: ErrorResponse) {
    this.error = params;
  }

  @Action
  async fetchFolders(): Promise<void> {
    this.context.commit('updateFolders', []);
    this.context.commit('setError', null);

    try {
      const { data }: CustomAxiosResponse = await axios.get(`folders`);

      this.context.commit('updateFolders', data);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }

  @Action
  async fetchRootFolders(): Promise<void> {
    this.context.commit('updateFolders', []);
    this.context.commit('setError', null);

    try {
      const { data }: CustomAxiosResponse = await axios.get(`folders/root`);

      this.context.commit('updateFolders', data);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }

  @Action
  async fetchSubfolders(parentId: number): Promise<void> {
    this.context.commit('updateFolders', []);
    this.context.commit('setError', null);

    try {
      const { data }: CustomAxiosResponse = await axios.get(
        `folders/subfolders/${parentId}`,
      );

      this.context.commit('updateFolders', data);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }

  @Action
  async fetchFolderById(id: number): Promise<void> {
    this.context.commit('updateFolder', null);
    this.context.commit('setError', null);

    try {
      const { data }: CustomAxiosResponse = await axios.get(`folders/id/${id}`);

      this.context.commit('updateFolder', data);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }

  @Action
  async fetchFolderByUuid(uuid: string): Promise<void> {
    this.context.commit('updateFolder', null);
    this.context.commit('setError', null);

    try {
      const { data }: CustomAxiosResponse = await axios.get(
        `folders/uuid/${uuid}`,
      );

      this.context.commit('updateFolder', data);
    } catch (error) {
      this.context.commit('setError', error);
    }
  }
}

export default getModule(FolderStore);
